// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"b9dd64b36790fecbce8e","293":"f7849e0a5ca849390126","522":"8c13195fcc291316b047"}[chunkId] + ".js";
};